module.exports = __webpack_public_path__ + "img/Left Front Door.01cfba25.png";